import DressageStep from "./DressageStep";

export default class DressageSteps {
  private data: DressageStep[] = [];

  constructor(items?: DressageStep[] | undefined) {
    if (items) {
      items.forEach(i => this.data.push(i));
    }
  }

  add(item: DressageStep) {
    this.data.push(item);
  }

  map<T>(mapFunction: (arg: DressageStep) => T): T[] {
    return Array.from(this.data.values()).map(mapFunction);
  }

  sort(sortFunction: (arg1: DressageStep, arg2: DressageStep) => number): DressageStep[] {
    return Array.from(this.data.values()).sort(sortFunction);
  }

  filter<T>(filterFunction: (arg: DressageStep) => boolean): DressageSteps {
    return new DressageSteps(Array.from(this.data.values()).filter(filterFunction));
  }

  forEach(forEachFunction: (arg: DressageStep, index: number) => void): void {
    return Array.from(this.data.values()).forEach(forEachFunction);
  }
}
